import { OutlinedInputClassKey } from '@material-ui/core/OutlinedInput';
import { Theme } from '@material-ui/core/styles';

const MuiOutlinedInput = (theme: Theme): Partial<Record<OutlinedInputClassKey, unknown>> => {
    const WebkitBoxShadow =
        theme.palette.type === 'light' ? null : `0 0 0 100px ${theme.palette.background.default} inset`;

    return {
        /* Styles applied to the root element. */
        root: {
            '&:hover $notchedOutline': {
                borderColor: theme.palette.grey[500],
            },
            '&$focused $notchedOutline': {
                borderColor: theme.palette.primary.main,
                borderWidth: 1,
            },
            '&$error $notchedOutline': {
                borderColor: theme.palette.error.main,
            },
            '&$disabled $notchedOutline': {
                borderColor: theme.palette.action.disabledBackground,
            },
            '&:not($marginDense) $notchedOutline': {
                '& legend': {
                    maxWidth: 0,
                },
                '& legend > span': {
                    padding: 0,
                },
            },
        },
        /* Styles applied to the root element if the color is secondary. */
        colorSecondary: {
            '&$focused $notchedOutline': {
                borderColor: theme.palette.secondary.main,
            },
        },
        /* Styles applied to the root element if `startAdornment` is provided. */
        adornedStart: {
            paddingLeft: 24,
        },
        /* Styles applied to the root element if `endAdornment` is provided. */
        adornedEnd: {
            paddingRight: 24,
        },
        /* Styles applied to the root element if `multiline={true}`. */
        multiline: {
            padding: '10.5px 24px',
            '&$marginDense': {
                paddingTop: 6.5,
                paddingBottom: 6.5,
            },
        },
        /* Styles applied to the `input` element. */
        input: {
            padding: '18.5px 24px 10.5px',
            '&:-webkit-autofill': {
                WebkitBoxShadow,
                borderRadius: 'inherit',
            },
        },
        /* Styles applied to the `input` element if `margin="dense"`. */
        inputMarginDense: {
            paddingTop: 6.5,
            paddingBottom: 6.5,
        },
        /* Styles applied to the `NotchedOutline` element. */
        notchedOutline: {
            borderColor: theme.palette.grey[400],
            padding: '0 18.5px',
        },
    };
};

export default MuiOutlinedInput;
